// Environment configuration for Handpicked Nanny
// This file centralizes all environment variable access

const config = {
  // Firebase Configuration
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBATAmS35my62009uAZ1lgt66h7kO3hEOU",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "app.handpickednanny.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "handpicked-dc4b7",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "handpicked-dc4b7.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef123456",
  },

  // Google Maps API
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyDCCNLE719tfQRXV3rqPZBZDBOXR-UGy9E",
  },

  // Stripe Configuration
  stripe: {
    publishableKeyTest: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST || "pk_test_51OWOgpIRATXzgEF0tx1Mui4Bk03FttlHB9stuMtdqM1gdUu03QlC6hE6KbjKvV8ZavAsHadOwRmuEkNl6fOudF2c00hZR5knjA",
    publishableKeyLive: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_LIVE || "pk_live_51HDdEjFzYsoDjWsuIsGxV1Ln8SSjEntOi1JeOvtbsTAZ6N19k46HPgejbXA8UNglzOOmN94SJL0FywmUzI6P7rCC00w771w8S7",
    testingMode: false,
  },

  // Application Configuration
  app: {
    name: process.env.REACT_APP_APP_NAME || "Handpicked Nanny",
    url: process.env.REACT_APP_APP_URL || "http://localhost:3000",
    testingMode: false,
  },

  // Email Configuration
  email: {
    sendGridApiKey: process.env.REACT_APP_SENDGRID_API_KEY || "",
    fromEmail: process.env.REACT_APP_FROM_EMAIL || "noreply@handpickednanny.com",
  },

  // Twilio Configuration
  twilio: {
    accountSid: process.env.REACT_APP_TWILIO_ACCOUNT_SID || "",
    authToken: process.env.REACT_APP_TWILIO_AUTH_TOKEN || "",
    phoneNumber: process.env.REACT_APP_TWILIO_PHONE_NUMBER || "",
  },

  // Helper functions
  getStripePublishableKey: () => {
    return config.stripe.testingMode 
      ? config.stripe.publishableKeyTest 
      : config.stripe.publishableKeyLive;
  },

  getGoogleMapsApiKey: () => {
    if (!config.googleMaps.apiKey || config.googleMaps.apiKey.includes('your_')) {
      console.warn('Google Maps API key not properly configured. Please set REACT_APP_GOOGLE_MAPS_API_KEY in your .env.local file');
    }
    return config.googleMaps.apiKey;
  },

  validateConfig: () => {
    const warnings = [];
    const errors = [];

    // Check for placeholder values
    if (config.googleMaps.apiKey.includes('your_')) {
      warnings.push('Google Maps API key is not configured');
    }

    if (config.stripe.publishableKeyTest.includes('your_')) {
      warnings.push('Stripe test publishable key is not configured');
    }

    if (config.stripe.publishableKeyLive.includes('your_')) {
      warnings.push('Stripe live publishable key is not configured');
    }

    // Log warnings and errors
    if (warnings.length > 0) {
      console.warn('Configuration warnings:', warnings);
    }

    if (errors.length > 0) {
      console.error('Configuration errors:', errors);
    }

    return { warnings, errors };
  }
};

// Validate configuration on import
config.validateConfig();

export default config;


